import GjsEditor, {
	AssetsProvider,
	Canvas,
	EditorProps,
	ModalProvider,
} from "@grapesjs/react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import type { Editor, EditorConfig } from "grapesjs";
import { ExtraEditorProps } from "../../pages/CustomPages/CustomPage";
import { MAIN_BORDER_COLOR } from "./components/common";
import CustomAssetManager from "./components/CustomAssetManager";
import CustomModal from "./components/CustomModal";
import LeftSidebar from "./components/LeftSidebar";
import RightSidebar from "./components/RightSidebar";
import Topbar from "./components/Topbar";

const theme = createTheme({
	palette: {
		mode: "dark",
	},
});

const gjsOptions: EditorConfig = {
	height: "100vh",
	storageManager: false,
	undoManager: { trackSelection: false },
	selectorManager: { componentFirst: true },
	projectData: {
		assets: [
			"https://via.placeholder.com/350x250/78c5d6/fff",
			"https://via.placeholder.com/350x250/459ba8/fff",
			"https://via.placeholder.com/350x250/79c267/fff",
			"https://via.placeholder.com/350x250/c5d647/fff",
			"https://via.placeholder.com/350x250/f28c33/fff",
		],
		pages: [
			{
				name: "Home page",
				component: `<h1>GrapesJS React Custom UI</h1>`,
			},
		],
	},
};

export default function CustomDesignedEditor({
	addBlockToRoot,
	filteredCategories,
	exportJson,
	publishPage,
	updateThemeInfo,
	addProducts,
	saveThemeGlobal,
	...props
}: Partial<EditorProps> & ExtraEditorProps) {
	const onEditor = (editor: Editor) => {
		console.log("Editor loaded");
		(window as any).editor = editor;
	};

	return (
		// @ts-ignore
		<ThemeProvider theme={theme}>
			<GjsEditor
				className="gjs-custom-editor text-white bg-[#1F5AA6]"
				grapesjs="https://unpkg.com/grapesjs"
				grapesjsCss="https://unpkg.com/grapesjs/dist/css/grapes.min.css"
				options={gjsOptions}
				plugins={[
					{
						id: "gjs-blocks-basic",
						src: "https://unpkg.com/grapesjs-blocks-basic",
					},
				]}
				onEditor={onEditor}
				{...props}>
				<div className={`flex h-full border-t ${MAIN_BORDER_COLOR}`}>
					<LeftSidebar
						className={`gjs-column-r w-[300px] border-l ${MAIN_BORDER_COLOR}`}
						addBlockToRoot={addBlockToRoot}
						filteredCategories={filteredCategories}
						page={props.page}
					/>
					<div className="gjs-column-m flex flex-col flex-grow">
						<Topbar
							className="min-h-[48px]"
							{...props}
							publishPage={publishPage}
							updateThemeInfo={updateThemeInfo}
							addProducts={addProducts}
							saveThemeGlobal={saveThemeGlobal}
						/>
						<Canvas className="flex-grow gjs-custom-editor-canvas" />
					</div>
					<RightSidebar
						className={`gjs-column-r w-[300px] border-l ${MAIN_BORDER_COLOR}`}
						addBlockToRoot={addBlockToRoot}
						filteredCategories={filteredCategories}
					/>
				</div>
				<ModalProvider>
					{({ open, title, content, close }) => (
						<CustomModal
							open={open}
							title={title}
							children={content}
							close={close}
						/>
					)}
				</ModalProvider>
				<AssetsProvider>
					{({ assets, select, close, Container }) => (
						<Container>
							<CustomAssetManager
								assets={assets}
								select={select}
								close={close}
							/>
						</Container>
					)}
				</AssetsProvider>
			</GjsEditor>
		</ThemeProvider>
	);
}
